import {NorwegianMarket} from "../models/norwegianMarket";
import {DefaultMarket} from "../models/defaultMarket";

export class MarketService {
    getCurrent() {
        if (window.location.hostname.slice(-3) === '.no') {
            return new NorwegianMarket();
        }

        return new DefaultMarket();
    }
}
